import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../styles/side-bar.module.scss";
import {SIDE_BAR} from "../side-bar-module.consts";

export const SideBarModuleTab = observer(({controller, tab}) => {
  const {state} = controller
  const {selectedTabIndex} = state

  const tabProps = {
    className: classNames(styles.tab, {[styles.active_tab]: tab.index === selectedTabIndex}),
    onClick: () => controller.action(SIDE_BAR.ACTION_TYPES.onTabClick, {index: tab.index})
  }

  return <div {...tabProps}>{tab.name}</div>
})
